import React, { Fragment } from "react";

import { Cms as Value } from "@reactivated";

import {
    StrictBlockMap,
    TrackedStreamField,
} from "../PageSkeleton/TrackedStreamField";
import { toolboxBaseComponents } from "../PageSkeleton/toolboxBase";

interface Props {
    value: Value;
}

// toolboxBaseComponents is typed as Omit<StrictBlockMap<Toolbox>, "reusable_content">,
// which is structurally equal to StrictBlockMap<Cms["content"]> (a.k.a.
// ToolboxWithoutReusable) but TS can't infer that automatically.
const components = toolboxBaseComponents as StrictBlockMap<Value["content"]>;

export const ReusableContentBlock = ({ value }: Props) => {
    return (
        <TrackedStreamField
            tagName={Fragment}
            components={components}
            value={value.content}
        />
    );
};
